// extracted by mini-css-extract-plugin
export var addButton = "_dx-4";
export var contentBlockImage = "_dx-i";
export var contentBlockWidgetPreview = "_dx-g";
export var fulfillmentCutoffWidgetPreview = "_dx-9";
export var imageBackdrop = "_dx-6";
export var imageIcon = "_dx-8";
export var lowProfileImageContainer = "_dx-b";
export var lowProfileImageIcon = "_dx-f";
export var lowProfileImageIconContainer = "_dx-e";
export var lowProfileImagePlaceholder = "_dx-d";
export var lowProfileProductImage = "_dx-c";
export var lowProfileProductUpsellWidgetPreview = "_dx-a";
export var productCard = "_dx-5";
export var productImage = "_dx-7";
export var productReviewsWidgetPreview = "_dx-h";
export var progressBar = "_dx-1";
export var progressBarFill = "_dx-2";
export var progressBarTrack = "_dx-3";
export var shippingOptionWidgetPreview = "_dx-j";
export var shippingUpsellProgressBar = "_dx-k";
export var thresholdUpsellWidgetPreview = "_dx-0";